var _g, _g2, _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.782 246.954c-39.414 7.974-75.125.583-106.703-23.923l24.015-28.317s28.108 24.544 70.173 16.92l12.515 35.32zM61.871 186.504l-25.73 26.762C13.686 188.683-3.429 159.198.587 110.225l36.763 5.446c-2.651 25.478 5.965 51.929 24.521 70.833zM194.45 20.844l-21.52 30.302c-22.105-14.392-48.965-17.66-74.189-10.036L86.149 6.22C125.953-5.84 161.858-.044 194.45 20.844zM87.041 45.64c-25.184 12.68-40.466 32.362-47.444 57.763L3.222 95.818C14.373 57.192 36.44 28.213 72.5 11.526l14.541 34.113z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.123 163.621c-6.199 18.826-28.537 61.77-78.555 80.169L127.66 125.267l117.463 38.354z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.834 150.656l-35.672-11.553c8.07-52.045-29.706-80.83-29.706-80.83l23.664-28.629c34.462 30.418 49.94 70.017 41.714 121.012z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty_svg__filter0_d_117_3386)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.359,
    y: 55.878,
    width: 108.347,
    height: 138.778,
    rx: 6,
    fill: "url(#empty_svg__paint0_linear_117_3386)"
  })), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 130.16,
    y: 162.953,
    width: 76.746,
    height: 15.852,
    rx: 2,
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.16 140.308h75.617M130.16 128.762h75.617M130.16 151.114h44.016",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.615 62.142a4 4 0 014-4h95.833a4 4 0 014 4v51.383H116.615V62.142z",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.403 78.807c1.271 0 2.301-1.077 2.301-2.406 0-1.33-1.03-2.407-2.301-2.407-1.271 0-2.301 1.078-2.301 2.407s1.03 2.406 2.301 2.406zM174.537 94.433H156.98c-1.133 0-1.793-1.375-1.133-2.258l8.779-12.765a1.383 1.383 0 012.265 0l8.779 12.765c.661.981 0 2.258-1.133 2.258z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M180.65 94.173h-8.641c-1.313 0-1.969-1.428-1.313-2.416l4.266-6.038c.656-.878 1.86-.878 2.516 0l4.266 6.038c.984.988.218 2.416-1.094 2.416z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty_svg__filter1_d_117_3386)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 26.212,
    y: 55.878,
    width: 108.347,
    height: 138.778,
    rx: 6,
    fill: "url(#empty_svg__paint1_linear_117_3386)"
  })), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.7,
    x: 42.014,
    y: 162.953,
    width: 76.746,
    height: 15.852,
    rx: 2,
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.014 140.308h75.618M42.014 128.762h75.618M42.014 151.114h44.017",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.47 62.142a4 4 0 014-4h95.833a4 4 0 014 4v51.383H28.47V62.142z",
    fill: "#F1F3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.32 78.807c1.27 0 2.3-1.077 2.3-2.406 0-1.33-1.03-2.407-2.3-2.407-1.271 0-2.302 1.078-2.302 2.407s1.03 2.406 2.302 2.406zM86.455 94.433H68.898c-1.133 0-1.794-1.375-1.133-2.258l8.778-12.765a1.384 1.384 0 012.266 0l8.778 12.765c.661.981 0 2.258-1.132 2.258z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M92.566 94.173h-8.641c-1.313 0-1.97-1.428-1.313-2.416l4.266-6.038c.656-.878 1.86-.878 2.516 0l4.265 6.038c.985.988.219 2.416-1.094 2.416z",
    fill: "#D6DCE8"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty_svg__filter2_d_117_3386)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 65.871,
    y: 49.568,
    width: 121.179,
    height: 154.485,
    rx: 6,
    fill: "url(#empty_svg__paint2_linear_117_3386)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 83.545,
    y: 168.762,
    width: 85.835,
    height: 17.646,
    rx: 2,
    fill: "#D6DCE8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.545 143.554h84.573M83.545 130.701h84.573M83.545 155.582h49.229",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.397 56.088a4 4 0 014-4h108.13a4 4 0 014 4v57.651H68.397v-57.65z",
    fill: "#F1F3F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.376 95.652c-1.255 0-2.582-.01-3.982-.03-1.39-.032-2.753-.073-4.091-.124a219.785 219.785 0 01-3.655-.169 53.495 53.495 0 01-2.707-.23c-1.099-.124-1.949-.483-2.551-1.077-.591-.605-.886-1.425-.886-2.46v-2.43c0-.86.057-1.614.171-2.26.124-.656.316-1.26.575-1.814a9.03 9.03 0 011.105-1.723l1.322-1.645c.176-.871.389-1.732.638-2.583.259-.85.513-1.615.762-2.291.259-.687.472-1.21.637-1.569a5.011 5.011 0 011.789-2.075c.778-.523 1.68-.851 2.707-.984.363-.041.933-.077 1.711-.108a86.707 86.707 0 012.83-.092c1.1-.02 2.308-.031 3.625-.031 1.327 0 2.54.01 3.639.03 1.1.021 2.038.047 2.816.078.788.03 1.368.071 1.742.123 1.026.143 1.928.471 2.706.984a5.011 5.011 0 011.789 2.075c.166.36.373.882.622 1.569.249.676.498 1.44.747 2.29.259.852.477 1.713.653 2.584l1.322 1.645a8.974 8.974 0 011.104 1.723c.27.553.462 1.158.576 1.814.124.646.187 1.4.187 2.26v2.43c0 1.035-.301 1.855-.903 2.46-.601.594-1.446.953-2.535 1.076-.695.082-1.597.16-2.706.231-1.11.062-2.333.118-3.671.17-1.338.05-2.701.091-4.091.122-1.389.02-2.722.03-3.997.03zm-11.293-15.33c-.072.328-.041.569.094.722.145.154.388.226.731.216a240.58 240.58 0 012.504-.123 87.123 87.123 0 013.328-.108c1.286-.03 2.831-.046 4.636-.046 1.814 0 3.365.015 4.65.046 1.297.02 2.406.056 3.329.108.933.04 1.768.082 2.504.123.353.01.596-.062.731-.216.145-.153.177-.394.094-.722a29.372 29.372 0 00-.405-1.492 17.18 17.18 0 00-.498-1.476c-.165-.461-.321-.815-.466-1.061-.228-.4-.482-.692-.762-.876-.28-.185-.659-.308-1.136-.37-.508-.081-1.415-.138-2.722-.169a178.021 178.021 0 00-5.319-.061c-2.23 0-3.998.02-5.304.061-1.297.041-2.204.098-2.722.17-.467.05-.846.174-1.136.369-.28.184-.529.476-.746.876-.146.246-.306.6-.483 1.061-.166.451-.331.943-.497 1.476-.156.523-.291 1.02-.405 1.492zm.467 11.24c.715 0 1.306-.236 1.773-.708.477-.471.716-1.06.716-1.768 0-.697-.239-1.281-.716-1.753-.467-.471-1.058-.707-1.773-.707-.716 0-1.312.236-1.789.707-.477.472-.715 1.056-.715 1.753 0 .707.238 1.297.715 1.768.477.472 1.073.708 1.789.708zm6.828-.615h8.011c.528 0 .959-.164 1.291-.492.342-.339.513-.774.513-1.307 0-.523-.171-.948-.513-1.277-.332-.338-.763-.507-1.291-.507h-8.011c-.529 0-.964.17-1.306.507-.332.329-.498.754-.498 1.277 0 .533.166.968.498 1.307.342.328.777.492 1.306.492zm14.839.615c.715 0 1.312-.236 1.789-.708.477-.471.715-1.06.715-1.768 0-.697-.238-1.281-.715-1.753-.477-.471-1.074-.707-1.789-.707-.705 0-1.296.236-1.773.707-.477.472-.716 1.056-.716 1.753 0 .707.239 1.297.716 1.768.477.472 1.068.708 1.773.708zm-26.707 8.257c-.57 0-1.047-.19-1.431-.57a1.893 1.893 0 01-.575-1.398v-6.627l5.786 2.906v3.72a1.89 1.89 0 01-.576 1.4c-.383.38-.855.569-1.415.569h-1.789zm29.973 0c-.57 0-1.047-.19-1.431-.57a1.893 1.893 0 01-.575-1.398V94.13l5.802-2.906v6.627c0 .553-.197 1.02-.591 1.399-.384.38-.861.569-1.431.569h-1.774zm-38.17-19.405c-.072.328-.041.574.093.738.146.154.389.22.732.2.591-.03 1.192-.062 1.804-.092a93.78 93.78 0 012.053-.077c.757-.02 1.638-.041 2.644-.062l-.186.57-1.323 1.644c-.694.872-1.177 1.733-1.446 2.584-.27.85-.405 1.927-.405 3.229v6.365c-1.451-.05-2.81-.107-4.075-.169a50.876 50.876 0 01-3.033-.246c-1.089-.123-1.934-.481-2.535-1.076-.602-.605-.902-1.42-.902-2.445l-.016-2.43c0-.87.057-1.63.171-2.275.125-.646.322-1.25.591-1.814a9.473 9.473 0 011.089-1.723l1.322-1.645c.176-.871.389-1.732.638-2.583.249-.85.498-1.615.747-2.291.248-.687.461-1.21.637-1.569a5.165 5.165 0 011.773-2.09c.778-.534 1.691-.862 2.738-.985.487-.051 1.395-.097 2.722-.138a163.59 163.59 0 015.257-.093 5.8 5.8 0 00-1.073 1.354 7.845 7.845 0 00-.7 1.63c-1.638.01-2.945.035-3.92.076-.974.041-1.685.093-2.13.154-.477.062-.861.18-1.151.354-.28.174-.514.44-.7.8-.146.276-.312.65-.498 1.122a24.55 24.55 0 00-.513 1.491c-.156.523-.291 1.02-.405 1.492zm-.778 10.364c.643 0 1.177-.21 1.603-.63.435-.431.653-.965.653-1.6 0-.625-.218-1.148-.653-1.568-.426-.43-.96-.646-1.603-.646-.642 0-1.177.215-1.602.646-.425.42-.637.943-.637 1.568 0 .635.212 1.169.637 1.6.425.42.96.63 1.602.63zm-3.795 9.04c-.56 0-1.037-.189-1.431-.568-.384-.37-.575-.835-.575-1.4V90.9l5.786 2.891v4.06a1.89 1.89 0 01-.576 1.399c-.373.38-.845.569-1.415.569h-1.789z",
    fill: "#D6DCE8"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty_svg__paint0_linear_117_3386",
    x1: 168.498,
    y1: 52.668,
    x2: 168.498,
    y2: 196.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty_svg__paint1_linear_117_3386",
    x1: 80.35,
    y1: 52.668,
    x2: 80.35,
    y2: 196.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "empty_svg__paint2_linear_117_3386",
    x1: 126.421,
    y1: 45.995,
    x2: 126.421,
    y2: 205.718,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "empty_svg__filter0_d_117_3386",
    x: 92.359,
    y: 44.878,
    width: 152.347,
    height: 182.779,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_117_3386"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_117_3386",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "empty_svg__filter1_d_117_3386",
    x: 4.212,
    y: 44.878,
    width: 152.347,
    height: 182.779,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_117_3386"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_117_3386",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "empty_svg__filter2_d_117_3386",
    x: 43.871,
    y: 38.568,
    width: 165.179,
    height: 198.485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_117_3386"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_117_3386",
    result: "shape"
  })))));
}
export default SvgEmpty;